<template>
<svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-color-stop`]" width="1em" height="1em" v-bind="$attrs"><path d="M6 0.75C8.8995 0.75 11.25 3.10051 11.25 6C11.25 8.8995 8.8995 11.25 6 11.25C3.10051 11.25 0.75 8.8995 0.75 6C0.75 3.10051 3.10051 0.75 6 0.75ZM3.61426 5.50098C3.33898 5.50104 3.11542 5.72475 3.11523 6C3.11523 6.27541 3.33886 6.49896 3.61426 6.49902H8.38574C8.6611 6.49891 8.88477 6.27538 8.88477 6C8.88458 5.72478 8.66098 5.50109 8.38574 5.50098H3.61426Z" :fill="useCurrentColor ? 'currentColor' : '#86909C'"/></svg>
</template>
<script>

export default {
  name: 'IconColorStop',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
